import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UtilitiesMyDocument, UtilitiesMyDocumentAppCategory } from '@libs/generated-types/utilities';
import { TranslateModule } from '@ngx-translate/core';
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { ButtonModule } from 'primeng/button';
import { Dialog } from "primeng/dialog";
import { IconFieldModule } from "primeng/iconfield";
import { InputIconModule } from "primeng/inputicon";
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from "primeng/message";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { StepperModule } from 'primeng/stepper';
import { TableModule } from 'primeng/table';
import { TabsModule } from "primeng/tabs";
import { FileType } from "../../@core/components/repository-show-file-dialog/repository-show-file-dialog.component";
import { MyDocumentsService } from '../../services/my-documents.service';

@Component({
  selector: 'app-my-documents-mobile',
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    TranslateModule,
    Dialog,
    IconFieldModule,
    InputIconModule,
    TabsModule,
    StepperModule,
    MessageModule,
    PdfJsViewerModule,
    ProgressSpinnerModule
  ],
  templateUrl: './my-documents.component.html',
  styleUrl: './my-documents.component.scss'
})
export class MyDocumentsMobileComponent implements OnInit {

  constructor(private myDocumentsService: MyDocumentsService, private translate: TranslateModule) { }

  categories: UtilitiesMyDocumentAppCategory[] = [];

  documents: UtilitiesMyDocument[] = [];
  visibleDocuments: UtilitiesMyDocument[] = [];
  searchDocuments: string = '';

  selectedCategory: UtilitiesMyDocumentAppCategory | null = null;
  activeDocument: UtilitiesMyDocument | null = null;

  notesDialogVisible: boolean = false;

  activeDocumentNotes: string = '';

  activeTab = 0;

  activeNoteStep = 1;

  showDetailFileDialog = false;
  detailFileType = FileType.Pdf;
  fileUrl: any = '';
  fileName = '';

  loading: boolean = true;

  ngOnInit(): void {
    this.myDocumentsService.getMyDocumentsCategories().subscribe((cats) => {
      this.categories = cats;
      this.loading = false;
      this.selectedCategory = null;
      this.documents = [];
      this.visibleDocuments = [];
    });
  }

  selectCategory(category: UtilitiesMyDocumentAppCategory): void {
    this.selectedCategory = category;
    this.activeTab = 0;
    this.activeNoteStep = 1;
    this.myDocumentsService.getDocumentsByCategory(category.code).subscribe((docs) => {
      const orderedDocs = docs.sort((a, b) => a.archiveDate < b.archiveDate ? 1 : -1);
      this.documents = orderedDocs;
      this.visibleDocuments = orderedDocs;
    });
  }

  deselectCategory(): void {
    this.selectedCategory = null;
    this.documents = [];
    this.visibleDocuments = [];
    this.searchDocuments = '';
  }

  documentsHasNote(): boolean {
    return this.documents.some(doc => doc.note);
  }

  openDocumentNotes(document: UtilitiesMyDocument): void {
    this.activeDocumentNotes = document.note.toString() || '';
    this.notesDialogVisible = true;
    this.myDocumentsService.logNotes(document.id, this.selectedCategory?.code || '').subscribe();
  }

  onCloseDialog(): void {
    this.notesDialogVisible = false;
    this.activeDocumentNotes = '';
  }

  searchDocument(): void {
    this.visibleDocuments = this.documents.filter(doc =>
      doc.title.toLowerCase().includes(this.searchDocuments.toLowerCase())
    );
  }

  setActiveTab(tabIndex: number): void {
    this.activeTab = tabIndex;
  }

  setActiveNoteStep(step: number): void {
    this.activeNoteStep = step;
  }

  hasCategoryNotes(category: UtilitiesMyDocumentAppCategory | null): boolean {
    return (category?.notes?.length ?? 0) > 0;
  }

  hasCategoryWarnings(category: UtilitiesMyDocumentAppCategory | null): boolean {
    return (category?.warnings?.length ?? 0) > 0;
  }

  downloadDocumentPdf(document: UtilitiesMyDocument): void {
    this.activeDocument = document;
    this.myDocumentsService.generateDownloadToken(this.selectedCategory?.code || '', document.id).subscribe((token) => {
      this.initiateDocumentDownload(token.downloadToken);
    });
  }

  private initiateDocumentDownload(token: string): void {
    this.myDocumentsService.getDocumentFile(token, this.activeDocument?.title || 'Documento').subscribe(file => {
      this.showDetailFileDialog = true;
      const tempBlob = new Blob([file], { type: 'application/pdf' });
      const fileReader = new FileReader();
      fileReader.onload = () => {
        this.fileUrl = new Uint8Array(fileReader.result as ArrayBuffer);
      };
      fileReader.readAsArrayBuffer(tempBlob);
      this.fileName = this.activeDocument?.title || 'Documento';
    });
  }

  onCloseShowDialog() {
    this.showDetailFileDialog = false;
    this.fileUrl = '';
    this.fileName = '';
  }

  onError(e: any) {
    console.log('Error loading file', e);
  }

  onPdfLoaded(e: any) {
    console.log('PDF loaded', e);
  }

  getFileUrl(): void {
    //download file from link
    const blob = new Blob([this.fileUrl], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
